import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AUTH_TOKEN, AUTH_REFRESH_TOKEN, AUTH_CONFIRM_EMAIL_TOKEN } from 'constants/AuthConstant';
import { setAuthToken } from 'store/slices/authSlice';

const OAuth2RedirectHandler = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const searchParams = new URLSearchParams(location.search);

    const token = searchParams.get('token');
    const refreshToken = searchParams.get('refreshToken');
    const status = searchParams.get('status');

    useEffect(() => {
        console.log('Status:', status);
        console.log('Token:', token);
        console.log('Refresh Token:', refreshToken);

        if (status !== 'ERROR') {

            if (status === 'SUCCESS') {
                if (token && refreshToken) {
                    localStorage.setItem(AUTH_TOKEN, token);
                    localStorage.setItem(AUTH_REFRESH_TOKEN, refreshToken);
                    console.log('Tokens armazenados no localStorage');
                    dispatch(setAuthToken(token));
                }
                navigate('/dashboard');
            } else if (status === 'PENDING_MAIL') {
                localStorage.setItem(AUTH_CONFIRM_EMAIL_TOKEN, token);
                navigate('/auth/confirm-email');
            } else {
                localStorage.setItem(AUTH_CONFIRM_EMAIL_TOKEN, token);
                navigate('/auth/confirm-email');
            }
        } else {
            navigate('/login');
        }
    }, [status, token, refreshToken, navigate, dispatch]);

    return null;
};

export default OAuth2RedirectHandler;